import React from 'react'
import { Grid } from '@material-ui/core'
import { isBrowser, isTablet } from 'react-device-detect'

import { dimensionAspectRatio } from '../../../util/utilFunctions'
import { CarouselWrapper } from '../carouselWrapper'
import { MarketServiceDetail } from '../../marketService/marketServiceDetail'
import { getCarousalGrid, getMarginGrid } from '../../../helpers/jsxHelper'
import { responsiveCarousel } from '../../../util/enums/enums'

export default class ManufactureCarousel extends React.Component {
  state = {
    height: 230,
    gutter: 16,
  }
  //Get new height:
  getNewHeight = () => {
    // const { items } = this.props
    const width = document.querySelector('#section-heading')
    const dividedBy = width ? getCarousalGrid(width.offsetWidth, responsiveCarousel.manufacture) : 5
    // const dividedBy = isBrowser ? items.isBrowser : isTablet ? items.isTablet : items.isMobile
    const actualWidth = width && width.offsetWidth / dividedBy
    const gutter = width && getMarginGrid(width.offsetWidth, { lg: 16, md: 12, sm: 10 })
    const aspectRatio = dimensionAspectRatio(295, 230)
    const newHeight = actualWidth / aspectRatio - 5
    this.setState({ height: newHeight, gutter })
  }
  componentDidMount() {
    this.getNewHeight()
    window.addEventListener('resize', this.getNewHeight)
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.getNewHeight)
  }
  createChildren = () => {
    const { carouselData, getCategoryWiseBoats } = this.props
    const { height } = this.state

    return (
      carouselData &&
      carouselData.length > 0 &&
      carouselData.map(item => {
        return (
          <MarketServiceDetail
            value={item}
            key={item.id}
            getService={getCategoryWiseBoats}
            className="manufacturer-carousal cursor-pointer"
            height={height}
          />
        )
      })
    )
  }

  render() {
    const { items, btnColor, slidesToScroll } = this.props
    const { height, gutter } = this.state
    return (
      <CarouselWrapper
        items={items}
        btnColor={btnColor}
        isZoom
        gutter={gutter}
        slidesToScroll={slidesToScroll}
        responsiveNumber={responsiveCarousel.manufacture}
        height={height}
      >
        {this.createChildren()}
      </CarouselWrapper>
    )
  }
}
ManufactureCarousel.defaultProps = {
  slidesToScroll: 1,
}
